import { render, staticRenderFns } from "./HomeMain.vue?vue&type=template&id=865d98a0&scoped=true"
import script from "./HomeMain.vue?vue&type=script&lang=js"
export * from "./HomeMain.vue?vue&type=script&lang=js"
import style0 from "./HomeMain.vue?vue&type=style&index=0&id=865d98a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865d98a0",
  null
  
)

export default component.exports